import { GenericObjectType } from "@rjsf/utils";

import { ObjectSchema } from "../types/object-schema";

export const isObjectSchema = (schema: GenericObjectType | undefined): schema is ObjectSchema => {
  return !!schema && typeof schema !== "boolean" && schema.type === "object" && !!schema.properties;
};
